import QuestionPoll from './questionPoll'

export { QuestionPoll }
